import { zipCodeFormat } from 'common/helpers/addresses';
import { getDefaultCountryCode } from 'common/helpers/miscHelper';
import { phoneFormat } from 'common/helpers/phoneHelper';

export const handleAddressChange = (
  addressId,
  address,
  changeFunction,
  settings
) => {
  if (addressId === '') {
    const newAddress = {
      firstName: '',
      lastName: '',
      address: '',
      address2: '',
      city: '',
      stateCode: '',
      zipCode: '',
      phone: '',
      countryCode: getDefaultCountryCode(settings)
    };
    const keys = Object.keys(newAddress);
    keys.forEach((key) => {
      changeFunction(key, newAddress[key]);
    });
  } else {
    const keys = Object.keys(address);
    keys.forEach((key) => {
      switch (key) {
        case 'zipCode':
          changeFunction(key, zipCodeFormat(address[key], address.countryCode));
          break;
        case 'phone':
          changeFunction(key, phoneFormat(address[key], address.countryCode));
          break;
        case 'birthDate':
          if (address.birthDate) {
            changeFunction('birthDay', address.birthDate.substring(8, 10));
            changeFunction('birthMonth', address.birthDate.substring(5, 7));
            changeFunction('birthYear', address.birthDate.substring(0, 4));
          } else {
            changeFunction('birthDay', '');
            changeFunction('birthMonth', '');
            changeFunction('birthYear', '');
          }
          break;
        default: {
          changeFunction(key, address[key]);
        }
      }
    });
  }
};
